














































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

@Component({
  components: { VCDateTimePicker }
})
export default class FormRmkSebabKematian extends Vue {
  @Prop() form!: any;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "-" }) namaDpjp!: string;

  barisPart1 = [
    { key: "part1_a", label: "a. Penyakit / keadaan yang langsung mengakibatkan kematian *", hint: "Wajib diisi sebelum tanda tangan DPJP" },
    { key: "part1_b", label: "b. Disebabkan oleh (akibat dari)", hint: "" },
    { key: "part1_c", label: "c. Disebabkan oleh (akibat dari) — pokok pangkal terakhir", hint: "" },
  ];

  /** Picker menerima Date, kolomnya date — simpan tetap "YYYY-MM-DD". */
  get tglKeterangan(): Date | null {
    const val = this.form && this.form.tgl_keterangan;
    return val ? moment(val).toDate() : null;
  }

  setTglKeterangan(val: Date | null) {
    this.form.tgl_keterangan = val ? moment(val).format("YYYY-MM-DD") : null;
    this.emitUpdate();
  }

  emitUpdate() {
    this.$emit("update", this.form);
  }
}
